import React, { useState } from "react";
import { Tooltip, Popover } from "antd";
import { RootState } from "../../../../../../store/app";
import { useSelector } from 'react-redux';
import { get_users_industry } from "../../../../../../config/Global";
import type { CollapseProps } from 'antd';
import { Collapse } from 'antd';
import { RightOutlined } from "@ant-design/icons";
import { PieChart, pieChartDefaultProps } from 'react-minimal-pie-chart';
import ArrowIcon from "../../../../../../assets/images/icon/profile-arrow-icon.svg?react";
const CareerWheel = ({ resultData }: any) => {
    const { career_categories, result } = resultData;


    const [hovered, setHovered] = useState(undefined);
    const lineWidth = 60;

    const CC1Image = <>
        <path stroke="#78C36A" fill="#78C36A" strokeWidth={1.5} strokeMiterlimit={10} d="M23.59,2.46c-5.84,0-11.12,2.37-14.94,6.19c-3.82,3.82-6.19,9.11-6.19,14.94c0,5.84,2.37,11.12,6.19,14.94
	c3.82,3.82,9.11,6.19,14.94,6.19s11.12-2.37,14.94-6.19c3.82-3.82,6.19-9.11,6.19-14.94c0-5.84-2.37-11.12-6.19-14.94
	C34.71,4.83,29.43,2.46,23.59,2.46z M23.59,20.62c-0.82,0-1.57,0.33-2.1,0.87c-0.54,0.54-0.87,1.28-0.87,2.1
	c0,0.82,0.33,1.56,0.87,2.1c0.54,0.54,1.28,0.87,2.1,0.87c0.82,0,1.56-0.33,2.1-0.87c0.54-0.54,0.87-1.28,0.87-2.1
	c0-0.82-0.33-1.56-0.87-2.1C25.16,20.95,24.41,20.62,23.59,20.62z M19.94,19.94c0.93-0.93,2.22-1.51,3.65-1.51
	c1.43,0,2.72,0.58,3.65,1.51c0.93,0.93,1.51,2.22,1.51,3.65c0,1.43-0.58,2.72-1.51,3.65c-0.93,0.93-2.22,1.51-3.65,1.51
	c-1.43,0-2.72-0.58-3.65-1.51c-0.93-0.93-1.51-2.22-1.51-3.65C18.43,22.17,19.01,20.88,19.94,19.94z M5.35,24.69
	c-0.6,0-1.09-0.49-1.09-1.09c0-0.6,0.49-1.09,1.09-1.09h3.96c0.27-3.52,1.8-6.68,4.15-9.03c2.35-2.35,5.51-3.89,9.03-4.15V5.35
	c0-0.6,0.49-1.09,1.09-1.09c0.6,0,1.09,0.49,1.09,1.09v3.96c3.52,0.27,6.68,1.8,9.03,4.15c2.35,2.35,3.89,5.51,4.15,9.03h3.96
	c0.6,0,1.09,0.49,1.09,1.09c0,0.6-0.49,1.09-1.09,1.09h-3.96c-0.27,3.52-1.8,6.68-4.15,9.03c-2.35,2.35-5.51,3.89-9.03,4.15v3.96
	c0,0.6-0.49,1.09-1.09,1.09c-0.6,0-1.09-0.49-1.09-1.09v-3.96c-3.52-0.27-6.68-1.8-9.03-4.15c-2.35-2.35-3.89-5.51-4.15-9.03H5.35z
	 M11.51,22.5h1.98c0.6,0,1.09,0.49,1.09,1.09c0,0.6-0.49,1.09-1.09,1.09h-1.98c0.26,2.91,1.55,5.53,3.5,7.49
	c1.96,1.95,4.57,3.24,7.49,3.5V33.7c0-0.6,0.49-1.09,1.09-1.09c0.6,0,1.09,0.49,1.09,1.09v1.98c2.91-0.26,5.53-1.55,7.49-3.5
	c1.96-1.96,3.24-4.57,3.5-7.49H33.7c-0.6,0-1.09-0.49-1.09-1.09c0-0.6,0.49-1.09,1.09-1.09h1.98c-0.26-2.91-1.55-5.53-3.5-7.49
	c-1.96-1.96-4.57-3.24-7.49-3.5v1.98c0,0.6-0.49,1.09-1.09,1.09c-0.6,0-1.09-0.49-1.09-1.09v-1.98c-2.91,0.26-5.53,1.55-7.49,3.5
	C13.06,16.97,11.77,19.59,11.51,22.5z M7.1,7.1c4.22-4.22,10.05-6.83,16.49-6.83c6.44,0,12.27,2.61,16.49,6.83
	c4.22,4.22,6.83,10.05,6.83,16.49c0,6.44-2.61,12.27-6.83,16.49c-4.22,4.22-10.05,6.83-16.49,6.83c-6.44,0-12.27-2.61-16.49-6.83
	c-4.22-4.22-6.83-10.05-6.83-16.49C0.27,17.15,2.88,11.32,7.1,7.1z"/>
    </>

    const CC2Image = <>
        <path fill="#2EA749" d="M73.92,13.47c1.16,0.34,1.92,0.42,2.03,0.43l0.09-1.14c-0.09-0.01-8.9-0.86-14.67-12.43L61.22,0h-0.64h-2.43
	h-0.6l-0.1,0.45c-0.11,0.5-2.98,12.3-19.43,12.3c-16.45,0-19.32-11.8-19.43-12.3L18.49,0h-0.6h-2.43h-0.64l-0.16,0.32
	C8.9,11.88,0.09,12.74,0,12.75l0.09,1.14c0.1-0.01,0.87-0.09,2.03-0.43v6.3H0v2.01h15.46v10.6h-1.02v3.25h4.57v-3.25h-1.12v-10.6
	h20.13h20.13v10.6h-1.12v3.25h4.57v-3.25h-1.02v-10.6h15.46v-2.01h-2.12V13.47z M5.54,19.76H2.76v-6.5
	c0.81-0.27,1.75-0.67,2.79-1.23V19.76z M8.97,19.76H6.19v-8.11c0.89-0.53,1.83-1.18,2.78-2V19.76z M12.4,19.76H9.61V9.1
	c0.93-0.85,1.86-1.86,2.78-3.03V19.76z M15.46,19.76h-2.43V5.24c0.84-1.16,1.66-2.48,2.43-3.97V19.76z M19.25,19.76h-1.36V1.96
	c0.28,0.71,0.71,1.66,1.36,2.72V19.76z M22.68,19.76h-2.78V5.66c0.72,1.01,1.63,2.09,2.78,3.11V19.76z M26.1,19.76h-2.79V9.31
	c0.82,0.66,1.74,1.28,2.79,1.85V19.76z M29.53,19.76h-2.78V11.5c0.85,0.42,1.78,0.81,2.78,1.14V19.76z M32.95,19.76h-2.78v-6.93
	c0.87,0.26,1.8,0.47,2.78,0.64V19.76z M36.38,19.76h-2.78v-6.19c0.88,0.13,1.81,0.22,2.78,0.27V19.76z M39.02,19.76h-1h-1v-5.89
	c0.33,0.01,0.66,0.02,1,0.02c0.34,0,0.67-0.01,1-0.02V19.76z M42.45,19.76h-2.79v-5.91c0.98-0.05,1.9-0.14,2.79-0.27V19.76z
	 M45.87,19.76h-2.79v-6.29c0.99-0.17,1.91-0.39,2.79-0.64V19.76z M49.3,19.76h-2.79v-7.13c1.01-0.33,1.93-0.72,2.79-1.14V19.76z
	 M52.73,19.76h-2.79v-8.6c1.04-0.57,1.97-1.2,2.79-1.85V19.76z M56.15,19.76h-2.79v-11c1.15-1.02,2.07-2.09,2.79-3.11V19.76z
	 M58.15,19.76h-1.36V4.68c0.65-1.06,1.08-2.01,1.36-2.72V19.76z M63,19.76h-2.43V1.26c0.77,1.49,1.59,2.81,2.43,3.97V19.76z
	 M66.43,19.76h-2.79V6.07c0.92,1.17,1.86,2.18,2.79,3.03V19.76z M69.86,19.76h-2.79V9.66c0.96,0.81,1.9,1.47,2.79,2V19.76z
	 M73.28,19.76H70.5v-7.73c1.04,0.56,1.98,0.96,2.79,1.23V19.76z"/>
    </>
    const CC3Image = <>
        <path stroke="#0C9FB1" fill="#0C9FB1" strokeWidth={0.5} strokeMiterlimit={10} d="M40.14,0.25c-0.71,0.03-1.43,0.2-2.11,0.52L24.69,7.02c-0.36,0.17-0.52,0.6-0.35,0.96l2.29,4.77
		c0.08,0.17,0.23,0.3,0.41,0.37c0.18,0.07,0.38,0.05,0.56-0.03l2.3-1.08c1.53-0.72,3.36-0.18,4.15,1.22
		c0.44,0.78,0.52,1.7,0.22,2.54c-0.28,0.77-0.85,1.4-1.6,1.75l-2.41,1.13c-0.18,0.08-0.31,0.23-0.38,0.41
		c-0.07,0.18-0.05,0.38,0.03,0.55l2.79,5.81c0.17,0.36,0.61,0.51,0.97,0.34l4.69-2.2l0.9,1.87c0.52,1.09,1.44,1.91,2.59,2.32
		c0.5,0.18,1.02,0.26,1.54,0.26c0.77,0,1.55-0.19,2.24-0.58c2.08-1.15,2.89-3.78,1.84-5.98l-0.85-1.77l4.69-2.2
		c0.36-0.16,0.52-0.59,0.34-0.95L45.34,3.35C44.37,1.32,42.28,0.17,40.14,0.25z M40.2,1.69c1.57-0.06,3.1,0.78,3.82,2.27l6.01,12.53
		l-4.69,2.2c-0.36,0.17-0.52,0.6-0.35,0.96l1.16,2.42c0.72,1.52,0.18,3.32-1.23,4.1c-0.8,0.44-1.71,0.52-2.57,0.21
		c-0.78-0.28-1.41-0.84-1.77-1.58l-1.21-2.52c-0.08-0.17-0.23-0.31-0.41-0.37c-0.08-0.03-0.16-0.04-0.25-0.04
		c-0.11,0-0.21,0.03-0.31,0.07l-4.69,2.2l-2.16-4.5l1.75-0.82c1.1-0.51,1.93-1.42,2.35-2.57c0.44-1.23,0.32-2.59-0.32-3.73
		c-1.17-2.06-3.82-2.86-6.05-1.82l-1.64,0.77l-1.66-3.46l12.68-5.94C39.15,1.84,39.68,1.72,40.2,1.69z M5.74,10.77
		c-3.03,0-5.49,2.43-5.49,5.42v14.59v14.59c0,2.99,2.46,5.42,5.49,5.42H20.5h14.76c3.03,0,5.49-2.43,5.49-5.42V30.79
		c0.01-0.4-0.32-0.72-0.72-0.72h-5.92c-0.4,0-0.73,0.32-0.73,0.72v2.68c0,1.68-1.27,3.07-2.89,3.18c-0.91,0.06-1.77-0.26-2.42-0.89
		c-0.59-0.59-0.91-1.36-0.91-2.18v-2.79c0-0.4-0.32-0.72-0.73-0.72h-5.19v-4.99h1.93c1.22,0,2.37-0.47,3.23-1.33
		c0.93-0.93,1.41-2.2,1.33-3.51c-0.16-2.36-2.22-4.2-4.68-4.2h-1.82v-4.55c0-0.4-0.33-0.72-0.73-0.72H5.74z M5.74,12.21h14.03v4.55
		c0,0.4,0.33,0.72,0.73,0.72h2.55c1.7,0,3.11,1.26,3.22,2.86c0.06,0.89-0.27,1.76-0.9,2.39c-0.59,0.58-1.37,0.9-2.2,0.9h-2.66
		c-0.4,0-0.73,0.32-0.73,0.72v5.71h-4.46v-1.91c0-1.21-0.48-2.34-1.34-3.2c-0.94-0.92-2.23-1.4-3.55-1.31
		c-2.38,0.16-4.25,2.19-4.25,4.62v1.8H1.71V16.2C1.71,14,3.52,12.21,5.74,12.21z M10.86,25.08c0.78,0.03,1.52,0.35,2.08,0.9
		c0.59,0.58,0.91,1.35,0.91,2.17v2.63c0,0.4,0.33,0.72,0.73,0.72h5.19v4.41h-1.94c-1.22,0-2.37,0.47-3.23,1.32
		c-0.93,0.92-1.42,2.2-1.33,3.51c0.16,2.36,2.22,4.21,4.68,4.21h1.82v4.41H5.75c-2.23,0-4.04-1.79-4.04-3.99V31.51h5.19
		c0.4,0,0.73-0.32,0.73-0.72v-2.52c0-1.68,1.27-3.08,2.89-3.18C10.64,25.08,10.75,25.08,10.86,25.08z M21.24,31.51h4.46v2.07
		c0,1.2,0.47,2.34,1.34,3.19c0.93,0.92,2.23,1.41,3.55,1.31c2.38-0.16,4.25-2.19,4.25-4.62v-1.96h4.46v13.87
		c0,2.2-1.81,3.98-4.03,3.98H21.24v-5.13c0-0.4-0.33-0.72-0.73-0.72h-2.55c-1.7,0-3.11-1.26-3.23-2.86c-0.06-0.9,0.26-1.75,0.9-2.39
		c0.59-0.58,1.37-0.9,2.2-0.9h2.67c0.4,0,0.73-0.32,0.73-0.72V31.51z"/>
    </>
    const CC4Image = <>
        <path stroke="#68CCE7" fill="#68CCE7" strokeMiterlimit={3.8502} d="M20.15,39.8c-3.89,0-7.68-1.15-10.92-3.31C6,34.33,3.48,31.26,2,27.67c-1.49-3.59-1.88-7.54-1.12-11.35
	C1.64,12.5,3.51,9,6.25,6.25C9,3.51,12.5,1.64,16.31,0.88C20.13,0.12,24.08,0.51,27.67,2c3.59,1.49,6.66,4.01,8.82,7.24
	c2.16,3.23,3.31,7.03,3.31,10.92c0,5.21-2.07,10.21-5.75,13.89C30.36,37.72,25.36,39.8,20.15,39.8z M20.15,2.25
	c-3.54,0-7,1.05-9.94,3.02c-2.94,1.97-5.24,4.76-6.59,8.03c-1.36,3.27-1.71,6.87-1.02,10.34c0.69,3.47,2.39,6.66,4.9,9.16
	c2.5,2.5,5.69,4.21,9.16,4.9c3.47,0.69,7.07,0.34,10.34-1.02c3.27-1.35,6.07-3.65,8.03-6.59c1.97-2.94,3.02-6.4,3.02-9.94
	c0-4.75-1.89-9.3-5.24-12.66C29.45,4.13,24.89,2.25,20.15,2.25z"/>
        <path stroke="#68CCE7" fill="#68CCE7" strokeMiterlimit={3.8502} d="M45.54,46.77L33.56,34.79l1.24-1.24l11.98,11.98L45.54,46.77z" />
        <path stroke="#68CCE7" fill="#68CCE7" strokeMiterlimit={3.8502} d="M7.29,25.53l7.85-7.88l5.99,5.99l0.27,0.27l0.27-0.27l10.12-10.1l1.22,1.22L21.4,26.4l-5.99-5.99l-0.27-0.27
	l-0.27,0.27l-6.37,6.34L7.29,25.53z"/>
    </>

    const CC5Image = <>
        <path stroke="#33BDCD" fill="none" strokeWidth={1.8} strokeMiterlimit={9.6255} d="M61.57,22.36v-4.2c0-0.16-0.15-0.31-0.31-0.31h-3.56c-0.15,0-0.31-0.08-0.31-0.23
	c-0.15-0.93-0.39-1.79-0.7-2.64c-0.08-0.16,0-0.31,0.15-0.39l3.1-1.79c0.15-0.08,0.23-0.31,0.08-0.39l-2.09-3.58
	c-0.08-0.16-0.31-0.23-0.39-0.08l-3.02,1.71c-0.15,0.08-0.31,0.08-0.39-0.08c-0.62-0.7-1.24-1.4-1.93-2.02
	c-0.08-0.08-0.15-0.23-0.08-0.39l1.7-3.03c0.08-0.16,0-0.31-0.08-0.39l-3.56-2.1c-0.15-0.08-0.31,0-0.39,0.08l-1.7,2.96
	c-0.08,0.16-0.23,0.16-0.39,0.16c-0.85-0.31-1.78-0.62-2.71-0.78c-0.15,0-0.23-0.16-0.23-0.31V1.21c0-0.16-0.15-0.31-0.31-0.31
	h-4.18c-0.15,0-0.31,0.15-0.31,0.31V4.4c0,0.16-0.08,0.31-0.23,0.31c-1.01,0.16-1.93,0.39-2.86,0.7c-0.15,0.08-0.31,0-0.39-0.15
	l-1.55-2.72c-0.08-0.15-0.31-0.23-0.39-0.08l-3.56,2.1c-0.15,0.08-0.23,0.31-0.08,0.39l1.55,2.64c0.08,0.16,0.08,0.31-0.08,0.39
	c-0.77,0.62-1.55,1.32-2.17,2.1c-0.08,0.08-0.23,0.16-0.39,0.08l-2.55-1.48c-0.15-0.08-0.31,0-0.39,0.08l-2.09,3.58
	c-0.08,0.16,0,0.31,0.08,0.39l2.55,1.48c0.15,0.08,0.15,0.23,0.15,0.39c-0.39,0.93-0.62,1.94-0.77,2.96c0,0.15-0.15,0.23-0.31,0.23
	h-3.1c-0.15,0-0.31,0.16-0.31,0.31v4.2c0,0.15,0.15,0.31,0.31,0.31h2.94c0.15,0,0.31,0.08,0.31,0.23c0.15,1.01,0.46,2.02,0.77,2.95
	c0.08,0.15,0,0.31-0.15,0.39l-2.55,1.48c-0.15,0.08-0.23,0.31-0.08,0.39l2.09,3.58c0.08,0.15,0.31,0.23,0.39,0.08l2.55-1.48
	c0.15-0.08,0.31-0.08,0.39,0.08c0.62,0.78,1.39,1.48,2.17,2.1c0.15,0.08,0.15,0.23,0.08,0.39l-1.55,2.64
	c-0.08,0.16,0,0.31,0.08,0.39l3.56,2.1c0.15,0.08,0.31,0,0.39-0.08l1.55-2.72c0.08-0.16,0.23-0.16,0.39-0.16
	c0.93,0.31,1.86,0.54,2.86,0.7c0.15,0,0.23,0.15,0.23,0.31v3.19c0,0.15,0.15,0.31,0.31,0.31h4.18c0.15,0,0.31-0.16,0.31-0.31v-3.34
	c0-0.15,0.08-0.23,0.23-0.31c0.93-0.16,1.86-0.47,2.71-0.78c0.15-0.08,0.31,0,0.39,0.16l1.7,2.95c0.08,0.16,0.31,0.23,0.39,0.08
	l3.56-2.1c0.15-0.08,0.23-0.31,0.08-0.39l-1.7-3.03c-0.08-0.16-0.08-0.31,0.08-0.39c0.7-0.62,1.31-1.24,1.93-2.02
	c0.08-0.15,0.23-0.15,0.39-0.08l3.02,1.79c0.15,0.08,0.31,0,0.39-0.08l2.09-3.58c0.08-0.16,0-0.31-0.08-0.39l-3.1-1.79
	c0,0,0-0.16,0-0.31c0.31-0.86,0.54-1.71,0.7-2.64c0-0.16,0.15-0.23,0.31-0.23h3.56C61.5,22.67,61.57,22.52,61.57,22.36z
	 M43.08,26.79c-4.49,0.78-8.36-3.11-7.58-7.62c0.46-2.72,2.63-4.98,5.34-5.37c4.49-0.78,8.36,3.11,7.58,7.62
	C48.03,24.15,45.87,26.33,43.08,26.79z"/>
        <path stroke="#33BDCD" fill="none" strokeWidth={1.8} strokeMiterlimit={9.6255} d="M29.31,45.07v-2.8c0-0.23-0.15-0.39-0.39-0.39h-2.4c-0.15,0-0.31-0.15-0.31-0.31
	c-0.08-0.62-0.23-1.17-0.46-1.71c-0.08-0.16,0-0.31,0.15-0.39l2.09-1.17c0.15-0.08,0.23-0.31,0.15-0.47l-1.47-2.49
	c-0.08-0.15-0.31-0.23-0.46-0.15l-2.01,1.17c-0.15,0.08-0.31,0.08-0.46-0.08c-0.39-0.47-0.77-0.93-1.24-1.32
	c-0.15-0.08-0.15-0.31-0.08-0.47l1.08-1.87c0.15-0.31,0.15-0.54-0.08-0.62l-2.4-1.4c-0.15-0.08-0.39-0.08-0.46,0.15l-1.08,1.94
	c-0.08,0.15-0.23,0.23-0.46,0.15c-0.54-0.23-1.16-0.39-1.78-0.54c-0.15,0-0.31-0.16-0.31-0.31v-2.02c0-0.39-0.15-0.54-0.39-0.54
	h-2.79c-0.23,0-0.39,0.15-0.39,0.39v2.1c0,0.16-0.15,0.31-0.31,0.39c-0.62,0.08-1.32,0.23-1.86,0.47c-0.15,0.08-0.31,0-0.39-0.16
	l-0.93-1.63c-0.15-0.31-0.39-0.39-0.54-0.31l-2.4,1.4c-0.15,0.08-0.23,0.31-0.15,0.47l1.01,1.71c0.08,0.16,0.08,0.31-0.08,0.47
	c-0.54,0.39-1.01,0.86-1.47,1.4c-0.08,0.16-0.31,0.16-0.46,0.08l-1.55-0.93c-0.31-0.16-0.54-0.16-0.62,0.08l-1.39,2.41
	c-0.08,0.15-0.08,0.39,0.15,0.47L4,39.16c0.15,0.08,0.23,0.23,0.15,0.47c-0.23,0.62-0.39,1.32-0.54,1.94c0,0.16-0.15,0.31-0.31,0.31
	H1.53c-0.39,0-0.54,0.16-0.54,0.39v2.8c0,0.23,0.15,0.39,0.39,0.39h1.86c0.15,0,0.31,0.16,0.31,0.31c0.15,0.7,0.31,1.32,0.54,1.94
	c0.08,0.16,0,0.31-0.15,0.47L2.3,49.11c-0.15,0.08-0.23,0.31-0.15,0.47l1.39,2.41c0.08,0.16,0.31,0.23,0.46,0.16l1.7-1.01
	c0.15-0.08,0.31-0.08,0.46,0.08c0.46,0.54,0.93,1.01,1.47,1.4c0.15,0.08,0.15,0.31,0.08,0.47l-0.93,1.56
	c-0.15,0.31-0.15,0.54,0.08,0.62l2.4,1.4c0.15,0.08,0.39,0.08,0.46-0.15l1.01-1.79c0.08-0.16,0.23-0.23,0.39-0.16
	c0.62,0.23,1.24,0.39,1.86,0.47c0.15,0,0.31,0.15,0.31,0.31v1.94c0,0.39,0.15,0.54,0.39,0.54h2.79c0.23,0,0.39-0.15,0.39-0.39v-2.18
	c0-0.15,0.15-0.31,0.31-0.31c0.62-0.15,1.24-0.31,1.78-0.54c0.15-0.08,0.31,0,0.46,0.15l1.01,1.79c0.15,0.31,0.39,0.39,0.54,0.31
	l2.4-1.4c0.15-0.08,0.23-0.31,0.15-0.47l-1.16-2.02c-0.08-0.15-0.08-0.31,0.08-0.47c0.46-0.39,0.85-0.85,1.24-1.32
	c0.08-0.15,0.31-0.15,0.46-0.08l1.86,1.09c0.31,0.16,0.54,0.16,0.62-0.08l1.39-2.41c0.08-0.15,0.08-0.39-0.15-0.47l-2.09-1.17
	c0-0.08-0.08-0.23,0-0.39c0.23-0.54,0.31-1.17,0.46-1.71c0-0.16,0.15-0.31,0.31-0.31h2.4C29.15,45.46,29.31,45.22,29.31,45.07z
	 M14.84,48.49c-2.63,0-4.8-2.18-4.8-4.82c0-2.64,2.17-4.82,4.8-4.82s4.8,2.18,4.8,4.82C19.71,46.31,17.54,48.49,14.84,48.49z"/>
    </>

    const CC6Image = <>
        <path stroke="#53B952" fill="#53B952" strokeWidth={0.8} strokeMiterlimit={10} d="M38.19,42.78c-1.24,0-2.41-0.48-3.28-1.36L21.37,27.88c-0.32-0.32-0.32-0.83,0-1.15l5.42-5.42
			c0.32-0.32,0.83-0.32,1.15,0l13.54,13.54c0.88,0.88,1.36,2.04,1.36,3.28c0,1.24-0.48,2.4-1.36,3.28
			C40.6,42.3,39.43,42.78,38.19,42.78z M23.09,27.31l12.97,12.97c1.18,1.18,3.09,1.18,4.27,0c1.18-1.18,1.18-3.09,0-4.27
			L27.36,23.04L23.09,27.31z"/>
        <path stroke="#53B952" fill="#53B952" strokeWidth={0.8} strokeMiterlimit={10} d="M17.74,21.08c-0.2,0-0.4-0.08-0.55-0.23L6.92,10.59l-1.97-0.33c-0.22-0.04-0.42-0.17-0.54-0.36L1.43,5.06
			C1.24,4.75,1.28,4.36,1.54,4.1l2.61-2.61c0.26-0.26,0.66-0.3,0.97-0.11l4.83,2.99c0.19,0.12,0.32,0.31,0.36,0.54l0.33,1.97
			L20.9,17.13c0.15,0.15,0.23,0.35,0.23,0.55c0,0.21-0.08,0.41-0.23,0.55l-2.61,2.61C18.14,21,17.94,21.08,17.74,21.08z M5.56,8.77
			l1.86,0.31c0.16,0.03,0.31,0.1,0.42,0.22l9.88,9.88l1.5-1.5L9.35,7.8C9.24,7.69,9.16,7.54,9.14,7.38L8.82,5.51L4.82,3.03
			L3.09,4.77L5.56,8.77z"/>
        <path stroke="#53B952" fill="#53B952" strokeWidth={0.8} strokeMiterlimit={10} d="M8.72,43.73c-2.14,0-4.28-0.82-5.91-2.44c-3.26-3.26-3.26-8.56,0-11.82c1.97-1.97,4.84-2.81,7.59-2.25
			l16.89-16.89c-0.57-2.75,0.27-5.62,2.25-7.59c2.08-2.08,5.16-2.9,8.05-2.14c0.28,0.07,0.49,0.29,0.57,0.57
			c0.08,0.28,0,0.57-0.21,0.77l-5.37,5.37l4.21,4.21l5.37-5.37c0.2-0.2,0.5-0.28,0.77-0.21c0.28,0.07,0.49,0.29,0.57,0.57
			c0.76,2.88-0.06,5.97-2.14,8.05c-1.97,1.97-4.84,2.81-7.59,2.25L16.88,33.69c0.56,2.75-0.28,5.62-2.25,7.59
			C13,42.91,10.86,43.73,8.72,43.73z M8.66,28.63c-1.76,0-3.44,0.68-4.72,1.96c-2.63,2.64-2.63,6.92,0,9.56
			c2.63,2.64,6.92,2.64,9.56,0c1.7-1.7,2.35-4.14,1.72-6.5c-0.07-0.28,0.01-0.57,0.21-0.77l17.52-17.52c0.2-0.2,0.49-0.28,0.77-0.21
			c2.37,0.62,4.8-0.02,6.5-1.72c1.35-1.35,2.04-3.16,1.95-5.03l-4.83,4.83c-0.15,0.15-0.35,0.24-0.57,0.24
			c-0.21,0-0.42-0.08-0.57-0.24l-5.34-5.35c-0.15-0.15-0.24-0.35-0.24-0.57c0-0.21,0.08-0.42,0.24-0.57l4.83-4.82
			c-1.85-0.08-3.68,0.6-5.03,1.95c-1.7,1.7-2.35,4.14-1.72,6.5c0.07,0.28-0.01,0.57-0.21,0.77L11.22,28.66
			c-0.2,0.2-0.5,0.28-0.77,0.21C9.85,28.71,9.25,28.63,8.66,28.63z M7.74,39.82c-0.21,0-0.41-0.08-0.57-0.23L4.5,36.92
			c-0.2-0.2-0.28-0.5-0.21-0.77l0.98-3.65c0.07-0.28,0.29-0.49,0.57-0.57l3.65-0.98c0.28-0.07,0.57,0.01,0.77,0.21l2.67,2.67
			c0.2,0.2,0.28,0.5,0.21,0.77l-0.98,3.65c-0.07,0.28-0.29,0.49-0.57,0.57L7.95,39.8C7.88,39.81,7.81,39.82,7.74,39.82z M5.96,36.11
			l2.02,2.02l2.76-0.74l0.74-2.76l-2.02-2.02L6.7,33.35L5.96,36.11z"/>
    </>






    const GlobalSettings: any = {
        cc1: { color: "#78C36A", image: CC1Image, xGap: 4.0, yGap: 4.0 },
        cc2: { color: "#2EA749", image: CC2Image, xGap: 6.3, yGap: 3.3 },
        cc3: { color: "#0C9FB1", image: CC3Image, xGap: 4.0, yGap: 4.5 },
        cc4: { color: "#68CCE7", image: CC4Image, xGap: 3.5, yGap: 3.5 },
        cc5: { color: "#33BDCD", image: CC5Image, xGap: 5.5, yGap: 5.5 },
        cc6: { color: "#53B952", image: CC6Image, xGap: 3.6, yGap: 4.0 }
    }


    /*  return result.find((res: any) => {
            return res.careers_detail.category_id == category.id
        }) || null */

    /*  */
    const filterdCC = career_categories == undefined ? [] : career_categories.filter((category: any) => {
        return category?.percentage ? parseFloat(category.percentage) > 0 : 0.00
    }).map((category: any, i: any) => {
        const mycc = category.code.toLowerCase().replace('s', '');
        if (mycc) {
            return {
                ...category,
                ...{
                    cc: mycc,
                    title: category.name,
                    color: GlobalSettings[mycc].color,
                    value: category?.percentage ? parseFloat(category.percentage) : 20,
                    image: GlobalSettings[mycc].image,
                    xGap: GlobalSettings[mycc].xGap,
                    yGap: GlobalSettings[mycc].yGap
                }
            };
        }
    });

    const items: CollapseProps['items'] = filterdCC.length == 0 ? [] : filterdCC.map((category: any) => {
        return {
            key: category.id,
            label: <h4><span className={category.cc}>
                <svg >
                    <g transform={`translate(5, 5) scale(0.4)`} >
                        {category.image}
                    </g>
                </svg>
            </span>{category.name}</h4>,
            children: <div className="accordian-common-category-description" dangerouslySetInnerHTML={{ __html: category.description }}></div>
        }
    });










    return <>
        {career_categories != undefined && career_categories.length > 0 ?
            <div className="graf-box">
                <div className='graphImage'>


                    <PieChart
                        center={[pieChartDefaultProps.radius, pieChartDefaultProps.radius]}
                        style={{
                            transition: "all 0.3s",
                            // height: '500px'

                        }}
                        startAngle={pieChartDefaultProps.startAngle}
                        // totalValue={100}
                        data={filterdCC}
                        radius={pieChartDefaultProps.radius - 12}
                        lineWidth={50}
                        // segmentsStyle={{ transition: 'all .3s', cursor: 'pointer' }}
                        segmentsShift={0}
                        animate

                        label={({ x, y, dx, dy, dataEntry }: any) => {
                            return <Tooltip title={dataEntry?.percentage ? <>{dataEntry.title} : {Math.round(dataEntry.percentage)}%</> : dataEntry.title} overlayClassName='examTooltip'>
                                <g >

                                    <circle style={{ transition: 'all .3s' }} cx={dx + x} cy={dy + y} r="10" fill="#fff" />
                                    <g

                                        style={{ transition: 'all .3s' }}
                                        transform={`translate(${dx + x - dataEntry.xGap}, ${dy + y - dataEntry.yGap}) scale(0.17)`} // Adjust scale and translation as needed
                                    >
                                        {dataEntry.image}

                                    </g>
                                </g >
                            </Tooltip>


                        }}

                        labelPosition={lineWidth * 1.7}

                    // onMouseOver={(_, index: any) => {
                    //     setHovered(index);
                    // }}
                    // onMouseOut={() => {
                    //     setHovered(undefined);
                    // }}
                    />
                </div>

                <Collapse
                    className="career-compass-categorys-accordian"
                    ghost
                    items={items}
                    expandIconPosition={'end'}
                    expandIcon={({ isActive }) => <ArrowIcon style={{ transition: 'rotate 0.3s', rotate: isActive ? '0deg' : '90deg' }} />}
                />
            </div>
            :
            <div className="graf-box">
                <div className='graphImage'>
                    <h5 className='graphInst'>Loading...</h5>
                </div>

            </div>
        }
    </>;
}

export default CareerWheel
